import { useRef, useEffect } from 'react'

export function usePrevious(value: any) {
  const ref = useRef()
  useEffect(() => void (ref.current = value), [value])
  return ref.current
}
